module.exports = __webpack_public_path__ + "img/08.f1218e91.jpg";